import { InfoRounded } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { Card, Typography } from '@otp/ui';
import { SuggestedTasksField } from 'src/components/most/list/history/columns/suggested-tasks';
import { ActionsField } from 'src/components/most/list/history/columns/actions';
import {
  MostRequestHistory,
  MostRequestHistoryListDocument,
} from 'src/graphql/generated/graphql';
import { useMostHistory } from 'src/hooks/query/most/use-most-history';
import { useState } from 'react';
import { RequestHistoryModal } from 'src/components/most/list/history/item/modal';

const MAX_SUGGESTED_TASKS = 1;
const MAX_RECENT_RESULTS = 3;

export const MostRecentCard = () => {
  const [selectedHistoryItem, setSelectedHistoryItem] =
    useState<MostRequestHistory>();

  const { records } = useMostHistory();

  const refetchQueries = [MostRequestHistoryListDocument];

  const suggestedTasks = records
    .filter((record) => record.suggestedTasks.length)
    .slice(0, MAX_SUGGESTED_TASKS)
    .map((record, index) => (
      <SuggestedTasksField
        key={index}
        store={record.store as { id: string; nationalStoreNumber: string }}
        tasks={record.suggestedTasks.slice(1)}
        refetchQueries={refetchQueries}
      />
    ));

  const recentResults = records.slice(
    0,
    MAX_RECENT_RESULTS,
  ) as MostRequestHistory[];

  return (
    <>
      <Stack direction="column" spacing={2} className="w-full">
        {suggestedTasks}

        {recentResults.map((record) => (
          <Card
            className="bg-[#F8F9FD] border-none w-full"
            onClick={() => setSelectedHistoryItem(record)}
            isLink
            withoutLinkIcon
          >
            <Stack
              direction="row"
              gap={2}
              justifyContent="space-between"
              alignItems="center"
            >
              <InfoRounded sx={{ fontSize: 20, color: 'primary.main' }} />
              <Typography variant="subtitle1" className="flex-1">
                {record.queryName || record.triageName}
              </Typography>
              <Typography variant="subtitle1">
                {record.store?.nationalStoreNumber}
              </Typography>
              <ActionsField record={record} refetchQueries={refetchQueries} />
            </Stack>
          </Card>
        ))}
      </Stack>
      {selectedHistoryItem && (
        <RequestHistoryModal
          item={selectedHistoryItem}
          onClose={() => setSelectedHistoryItem(undefined)}
        />
      )}
    </>
  );
};
